import { BRANDING_SECTION_ICON_WRAP, BRANDING_TITLE, BRANDING_SUBTITLE } from "../branding.tokens";

// Every card on this page opened with the same title-over-subtitle block,
// rewritten by hand five times (Draft Branding, Preview, Published, Assets,
// History) — one drifting a class from the others was only a matter of time.
// One component, and the icon badge gives each card a visual anchor a wall
// of identical gray boxes didn't have.
const BrandingSectionHeader = ({ icon: Icon, title, subtitle, action, className = "" }) => (
  <div className={`mb-3 flex items-start justify-between gap-2 ${className}`}>
    <div className="flex items-start gap-2.5 min-w-0">
      {Icon && (
        <span className={BRANDING_SECTION_ICON_WRAP}>
          <Icon className="h-3.5 w-3.5" aria-hidden="true" />
        </span>
      )}
      <div className="min-w-0">
        <h3 className={BRANDING_TITLE}>{title}</h3>
        {subtitle && <p className={BRANDING_SUBTITLE}>{subtitle}</p>}
      </div>
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);

export default BrandingSectionHeader;
